export const buildWlsCheckoutUrl = ({
  listingSlug,
  listingId,
  checkInDate,
  checkOutDate,
  guests,
  addonFeeIds,
  couponCode,
  customLocation,
  deliveryLocation,
  quoteId
}) => {
  const checkInDateFormatted = checkInDate.format('DD-MM-YYYY');
  const checkOutDateFormatted = checkOutDate.format('DD-MM-YYYY');
  const formattedAddonFeeIds = addonFeeIds ? addonFeeIds.join(',') : [];
  return `${'/checkout/' +
    `${listingSlug}/`}${listingId}?check-in=${checkInDateFormatted}&check-out=${checkOutDateFormatted}&guests=${guests}&addonFeeIds=${formattedAddonFeeIds}&couponCode=${couponCode}${(customLocation &&
    '&customLocation=true') ||
    (deliveryLocation ? `&deliveryLocation=${deliveryLocation}` : '')}${
    quoteId ? `&quote_id=${quoteId}` : ''
  }`;
};
